export default __webpack_public_path__ + "static/media/saksham.5d672193.jpeg";